[
  "Apple iPhone 17 Pro Max",
  "Apple iPhone 17 Pro",
  "Apple iPhone 17 Air",
  "Apple iPhone 17",
  "Apple iPhone 16e",
  "Apple iPhone 16 Pro Max",
  "Apple iPhone 16 Plus",
  "Apple iPhone 16 Pro",
  "Apple iPhone 16",
  "Apple iPhone 15 Pro Max",
  "Apple iPhone 15 Plus",
  "Apple iPhone 15 Pro",
  "Apple iPhone 15",
  "Apple iPhone 14 Pro Max",
  "Apple iPhone 14 Plus",
  "Apple iPhone 14 Pro",
  "Apple iPhone 14",
  "Apple iPhone SE 3 (2022)",
  "Apple iPhone 13 Pro Max",
  "Apple iPhone 13 Pro",
  "Apple iPhone 13 Mini",
  "Apple iPhone 13",
  "Apple iPhone 12 Pro Max",
  "Apple iPhone 12 Pro",
  "Apple iPhone 12 Mini",
  "Apple iPhone 12",
  "Apple iPhone SE 2 (2020)",
  "Apple iPhone 11 Pro Max",
  "Apple iPhone 11 Pro",
  "Apple iPhone 11",
  "Apple iPhone XS Max",
  "Apple iPhone XS",
  "Apple iPhone XR",
  "Apple iPad Pro 11″ (model A2068, from 2020)",
  "Apple iPad Pro 12.9″ (model A2069, from 2020)",
  "Apple iPad Air (model A2123, from 2019)",
  "Apple iPad (model A2198, from 2019)",
  "Apple iPad Mini (model A2124, from 2019)",
  "Apple iPad 10th generation (from 2022)",
  "Samsung Galaxy XCover7 Pro",
  "Samsung Galaxy A56",
  "Samsung Galaxy A55 5G",
  "Samsung Galaxy A54 5G",
  "Samsung Galaxy A36",
  "Samsung Galaxy A35 5G",
  "Samsung Galaxy A23 5G",
  "Samsung Galaxy Z Flip5",
  "Samsung Galaxy Z Flip6",
  "Samsung Galaxy Z Flip 7",
  "Samsung Galaxy Z Flip 7 FE",
  "Samsung Galaxy Z Fold",
  "Samsung Galaxy Z Fold3",
  "Samsung Galaxy Z Fold5",
  "Samsung Galaxy Z Fold6",
  "Samsung Galaxy Z Fold7",
  "Samsung Galaxy S25",
  "Samsung Galaxy S25 Edge",
  "Samsung Galaxy S25+",
  "Samsung Galaxy S25 Ultra",
  "Samsung Galaxy S25 Slim",
  "Samsung Galaxy S24 Ultra",
  "Samsung Galaxy S24+",
  "Samsung Galaxy S24 FE",
  "Samsung Galaxy S24",
  "Samsung Galaxy S23 FE (not all versions are compatible with eSIMs)",
  "Samsung Galaxy S23 Ultra",
  "Samsung Galaxy S23+",
  "Samsung Galaxy S23",
  "Samsung Galaxy S22 Ultra",
  "Samsung Galaxy S22+",
  "Samsung Galaxy S22",
  "Samsung Galaxy S21+ Ultra 5G",
  "Samsung Galaxy S21+ 5G",
  "Samsung Galaxy S21",
  "Samsung Galaxy S20 Ultra 5G",
  "Samsung Galaxy S20 Ultra",
  "Samsung Galaxy S20+ 5G",
  "Samsung Galaxy S20+",
  "Samsung Galaxy S20",
  "Samsung Galaxy Z Fold5 5G",
  "Samsung Galaxy Z Fold4",
  "Samsung Galaxy Z Fold3 5G",
  "Samsung Galaxy Z Fold2 5G",
  "Samsung Galaxy Fold",
  "Samsung Galaxy Z Flip5 5G",
  "Samsung Galaxy Z Flip4",
  "Samsung Galaxy Z Flip3 5G",
  "Samsung Galaxy Z Flip",
  "Samsung Galaxy A54 (not all versions are compatible with eSIMs)",
  "Samsung Galaxy Note 20 Ultra 5G",
  "Samsung Galaxy Note 20",
  "Google Pixel 10 Pro Fold",
  "Google Pixel 10 Pro XL",
  "Google Pixel 10 Pro",
  "Google Pixel 10",
  "Google Pixel 9 Pro Fold",
  "Google Pixel 9 Pro XL",
  "Google Pixel 9 Pro",
  "Google Pixel 9",
  "Google Pixel 9a",
  "Google Pixel Fold",
  "Google Pixel 8 Pro",
  "Google Pixel 8",
  "Google Pixel 8a",
  "Google Pixel 7 Pro",
  "Google Pixel 7",
  "Google Pixel 7a",
  "Google Pixel 6 Pro",
  "Google pixel 6a",
  "Google Pixel 6",
  "Google Pixel 5a",
  "Google Pixel 5",
  "Google Pixel 4 XL",
  "Google Pixel 4a",
  "Google Pixel 4",
  "Google Pixel 3a XL",
  "Google Pixel 3a (not all versions are compatible with eSIMs)",
  "Google Pixel 3 XL",
  "Google Pixel 3 (not all versions are compatible with eSIMs)",
  "Google Pixel 2 XL",
  "Google Pixel 2 (not all versions are compatible with eSIMs)",
  "Oppo Find X8 Pro",
  "Oppo Find X8",
  "Oppo Reno14 Pro",
  "Oppo Reno14",
  "Oppo Find N3",
  "Oppo Find N3 Flip",
  "Oppo Find X5 Pro",
  "Oppo Find X5",
  "Oppo A55s 5G",
  "Oppo Reno 9A",
  "Oppo Find N2 Flip",
  "Oppo Reno 6 Pro 5G",
  "Oppo Find X3 Pro",
  "Oppo Find X3",
  "Oppo Reno 5A",
  "Xiaomi 15",
  "Xiaomi 15 Ultra",
  "Xiaomi 14",
  "Xiaomi 14 Pro",
  "Xiaomi 14T",
  "Xiaomi 14T Pro",
  "Xiaomi 13T",
  "Xiaomi 13T Pro",
  "Xiaomi 13 Pro",
  "Xiaomi 13 Lite",
  "Xiaomi 13",
  "Xiaomi 12T Pro",
  "Xiaomi Poco X7",
  "Xiaomi Redmi Note 14 Pro",
  "Xiaomi Redmi Note 14 Pro 5G",
  "Xiaomi Redmi Note 14 Pro+",
  "Xiaomi Redmi Note 14 Pro+ 5G",
  "Xiaomi Redmi Note 13 Pro",
  "Xiaomi Redmi Note 13 Pro+",
  "Xiaomi Redmi Note 11 Pro 5G",
  "Vivo X200 Pro",
  "Vivo x200",
  "Vivo X200s",
  "Vivo X200 FE",
  "Vivo X100 Pro",
  "Vivo x90 Pro",
  "Vivo V29 (not all versions are compatible with eSIMs)",
  "Vivo V29 Lite 5c (not all versions are compatible with eSIMs)",
  "vivo V40",
  "Vivo V40 Lite (not all versions are compatible with eSIMs)",
  "Vivo V50",
  "OnePlus Open",
  "OnePlus 11",
  "OnePlus 12",
  "OnePlus 13",
  "OnePlus 13R",
  "Honor Magic V3",
  "Honor 200 Pro",
  "Honor Magic 6 Pro",
  "Honor Magic V2",
  "Honor 90",
  "Honor Magic 5 Pro",
  "Honor X8",
  "Honor Magic 4 Pro",
  "Honor 400 Lite",
  "Huawei Mate 40 Pro",
  "Huawei P40 Pro",
  "Huawei P40",
  "Huawei 80 Pro / Pro+ / Ultra",
  "Pura X foldable",
  "Sony Xperia 10 III Lite",
  "Sony Xperia 10 VI",
  "Sony Xperia 10 V",
  "Sony Xperia 10 IV",
  "Sony Xperia 1 VI",
  "Sony Xperia 1 V",
  "Sony Xperia 1 IV",
  "Sony Xperia 5 IV",
  "Sony Xperia Ace III",
  "Sony Xperia 5 V",
  "Sony Xperia 1 VII",
  "Motorola Edge 60",
  "Motorola Edge 60 Pro",
  "Motorola Edge 60 Fusion",
  "Motorola Edge 60 Stylus",
  "Motorola Edge 50",
  "Motorola Edge 50 Fusion",
  "Motorola Edge 50 Pro",
  "Motorola Edge 50 Neo",
  "Motorola Edge 50 Ultra",
  "Motorola Edge 40 Neo",
  "Motorola Edge 40 Pro",
  "Motorola Edge 40",
  "Motorola Edge+",
  "Motorola Edge+ (2023)",
  "Motorola Edge (2024)",
  "Motorola Edge (2023)",
  "Motorola Edge (2022)",
  "Motorola Razr 40",
  "Motorola Razr 40 Ultra",
  "Motorola Razr 60",
  "Motorola Razr 50",
  "Motorola Razr 50 Ultra",
  "Motorola Razr 2024",
  "Motorola Razr+ 2024",
  "Motorola Razr 2022",
  "Motorola Razr 2019",
  "Motorola Razr 5G",
  "Motorola ThinkPhone 25",
  "Sharp AQUOS sense4 lite",
  "Sharp AQUOS Sense6s",
  "AQUOS sense 7",
  "AQUOS sense 7plus",
  "Sharp AQUOS Wish",
  "AQUOS wish 2 SHG08",
  "AQUOS wish3",
  "AQUOS zero 6",
  "Simple Sumaho6",
  "Sharp AQUOS R7",
  "Sharp AQUOS R8",
  "Sharp AQUOS R8 Pro",
  "Sharp Aquos sense8",
  "Rakuten Mini",
  "Rakuten Big-S",
  "Rakuten Big",
  "Rakuten Hand",
  "Rakuten Hand 5G",
  "Tcl 60",
  "Tcl 60 XE NxtPaper",
  "Tcl 50 5G",
  "Tcl 50 NxtPaper",
  "Tcl 50 Pro NxtPaper",
  "Tcl 40 XL",
  "Gemini PDA",
  "Fairphone 4",
  "Fairphone 5",
  "DOOGEE V30",
  "OnePlus Open",
  "OnePlus 11",
  "OnePlus 12",
  "OnePlus 13",
  "OnePlus 13R",
  "HAMMER Blade 3",
  "HAMMER Explorer PRO",
  "HAMMER Blade 5G",
  "Nokia XR21",
  "Nokia X30",
  "Nokia G60 5G",
  "myPhone NOW eSIM",
  "OUKITEL WP30 Pro",
  "OUKITEL WP33 Pro",
  "Nuu X5",
  "ZTE Nubia Flip",
  "TLC 50 5G",
  "Asus ROG Phone 9",
  "Asus ROG Phone 9 Pro",
  "Realme 14 Pro+",
  "Realme GT 7",
  "Asus ROG Phone 9",
  "Asus ROG Phone 9 Pro",
  "Asus Zenfone 12 Ultra",
  "Samsung Galaxy S20 FE 4G/5G (not compatible)",
  "Samsung S20/S21 (US versions not compatible)",
  "Galaxy Z Flip 5G (US versions not compatible)",
  "Samsung Note 20 Ultra (Versions from the US and Hong Kong not compatible)",
  "Samsung Galaxy Z Fold 2 (Versions from the US and Hong Kong not compatible)",
  "Google Pixel 3 devices from Australia, Japan, and Taiwan (not compatible)",
  "Samsung Galaxy S10 (not compatible)",
  "Huawei P40 Pro+ (not compatible)",
  "Xiaomi 12T (not compatible)"
]
